import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const FilterPanelWrapper = styled.div`
  background: ${p => p.theme.bg.secondary};
  padding: ${layout.measurements.spacingNormal};
  border-radius: 8px;
  width: 100%;
`;
export const FilterPanel = styled.div`
  display: grid;
  gap: ${layout.measurements.spacingSmall};
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: row;

  width: 100%;
  margin-bottom: ${layout.measurements.spacingSmall};

  ${media.mediumDown`
    grid-template-rows: auto;
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  `};
`;

export const CheckboxOption = styled(Clickable)`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  text-align: left;

  &.focus-visible,
  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

type CheckboxProps = {
  checked?: boolean;
};

export const Checkbox = styled.div<CheckboxProps>`
  margin-right: ${layout.measurements.spacingSmall};
  display: flex;
  background: ${p => p.theme.colors.base0};
  border: 1px solid ${p => p.theme.inputs.primary.border};

  ${props =>
    props.checked &&
    css`
      background-color: ${props.theme.colors.maybeBlue700};
      border: 1px solid ${props.theme.colors.maybeBlue700};
    `}

  ${/* sc-selector */ CheckboxOption}.focus-visible &,
  ${/* sc-selector */ CheckboxOption}:hover & {
    border-color: ${p => p.theme.text.callToActionHover};
  }
`;
